import React from 'react';
import Arrow from '../../components/ui/Arrow';
import Button, { ButtonVariation } from '../../components/ui/Button';

interface CollectionPaginationProps {
  currentPage: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  isLoading?: boolean;
  onPrev: () => void;
  onNext: () => void;
  variant: 'compact' | 'full';
}

const CollectionPagination: React.FC<CollectionPaginationProps> = ({
  currentPage,
  hasPreviousPage,
  hasNextPage,
  isLoading = false,
  onPrev,
  onNext,
  variant,
}) => {
  if (variant === 'compact') {
    return (
      <nav className="collection-pagination collection-pagination--compact" aria-label="Pagination">
        <button
          type="button"
          className="collection-pagination__control"
          onClick={onPrev}
          disabled={!hasPreviousPage || isLoading}
          aria-label="Previous page"
        >
          <Arrow direction="left" />
        </button>
        <span className="collection-pagination__page" aria-current="page">
          {currentPage}
        </span>
        <button
          type="button"
          className="collection-pagination__control"
          onClick={onNext}
          disabled={!hasNextPage || isLoading}
          aria-label="Next page"
        >
          <Arrow direction="right" />
        </button>
      </nav>
    );
  }

  return (
    <nav className="collection-pagination collection-pagination--full" aria-label="Pagination">
      <ul className="pagination">
        <li className="pagination-item">
          <Button
            variation={ButtonVariation.ICON_ONLY_ROUNDED}
            className="pagination-arrow prev"
            onClick={onPrev}
            disabled={!hasPreviousPage || isLoading}
            aria-label="Previous page"
          >
            <Arrow direction="left" />
          </Button>
        </li>
        <li className="pagination-item active">
          <span className="pagination-link active" aria-current="page">
            {currentPage}
          </span>
        </li>
        <li className="pagination-item">
          <Button
            variation={ButtonVariation.ICON_ONLY_ROUNDED}
            className="pagination-arrow next"
            onClick={onNext}
            disabled={!hasNextPage || isLoading}
            aria-label="Next page"
          >
            <Arrow direction="right" />
          </Button>
        </li>
      </ul>
    </nav>
  );
};

export default CollectionPagination;
